// Model.js
// -----------------------
// @module Case
define("Paystand.PaystandExtensionV2.Paystand.Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({

        
});
});
